import React, { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import RightViewComponent from "./viewGuide/RightViewGuide";
import LeftViewComponent from "./viewGuide/LeftViewGuide";
import MiddleViewGuide from "./viewGuide/MiddleViewGuide";
import WebUtils from "../../../utils/WebUtils";
import Utils from "../../../utils/Utils";
import {
  getGuideDetails,
  getFreeGuideTopicsApi,
  viewGuideViewJDApi,
  getQuestionBankTopicsApi,
  getFreeQuestionBankTopicsApi,
  viewFreeGuideViewJDApi,
} from "../../../api/candidate/index";
import Loader from "../../Loader";
import "../../../styles/viewGuide.css";
import Slidersection from "../../slidercomponent/Slidersection";
import JobDetails from "../../slidercomponent/JobDetails";
import Notes from "../../slidercomponent/Notes";
import VideoCurator from "../../slidercomponent/VideoCurator";

const ViewGuideMain = ({ guideData }) => {
  const middleContentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { jobGuideIdentifier } = useParams();
  const [searchParams] = useSearchParams();
  const industryId = searchParams.get("industryId");

  const [guideDetails, setGuideDetails] = useState(null);
  const [questionBankTopics, setQuestionBankTopics] = useState(null);
  const [questionBankSkills, setQuestionBankSkills] = useState({});
  const [currentSkills, setCurrentSkills] = useState(null);
  const [skillRegenerateFlag, setSkillRegenerateFlag] = useState(null);
  const [qbSkillType, setQBSkillType] = useState(null);

  const userDetail = Utils.getUserDetail(); // Fetch user detail
  const [currTopicId, setCurrTopicId] = useState("");
  const [currSubTopicId, setCurSubTopicId] = useState("");

  const [open, setOpen] = useState(false);

  const [activeIndex, setActiveIndex] = useState(null);

  const buttons = [
    { id: 0, icon: "icon1" },
    { id: 1, icon: "icon2" },
    { id: 2, icon: "icon3" },
  ];

  // This function updates the topic and subtopic IDs in the main component
  const setTopicSubTopic = (subTopicId, topicId) => {
    setCurrTopicId(topicId);
    setCurSubTopicId(subTopicId);
  };

  const handleViewJd = () => {
    let url;
    if (industryId) {
      url = `${viewFreeGuideViewJDApi}?jobGuideIdentifier=${jobGuideIdentifier}`;
    } else {
      url = `${viewGuideViewJDApi}?userIdentifier=${
        userDetail?.userIdentifier || null
      }&jobGuideIdentifier=${jobGuideIdentifier}`;
    }

    setLoading(true);
    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          const jdLink = result.data.data;
          window.open(jdLink, "_blank");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  function initGetGuideDetails() {
    setLoading(true);
    if (jobGuideIdentifier) {
      let getGuideDetailUrl = "";

      if (industryId) {
        getGuideDetailUrl =
          getFreeGuideTopicsApi +
          `?userIdentifier=${userDetail?.userIdentifier}&industryId=${industryId}&jobGuideIdentifier=${jobGuideIdentifier}`;
      } else {
        getGuideDetailUrl =
          getGuideDetails +
          `?userIdentifier=${userDetail?.userIdentifier}&jobGuideIdentifier=${jobGuideIdentifier}`;
      }

      WebUtils.httpOperations(getGuideDetailUrl, {}, "GET")
        .then((result) => {
          setLoading(false);
          if (
            result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
          ) {
            setGuideDetails(result.data.data);
            guideData(result.data.data);

            //set the default subtopic id and topic id
            const defaultTitleSubtitles = result.data.data?.jobTopicList[0];
            if (defaultTitleSubtitles) {
              setCurrTopicId(defaultTitleSubtitles.topicIdentifier);
              setCurSubTopicId(
                defaultTitleSubtitles.jobSubTopic[0]?.subTopicIdentifier
              );
            }
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  }

  function getQuestionBankTopics() {
    setLoading(true);
    if (jobGuideIdentifier) {
      let url;
      if (industryId) {
        url =
          getFreeQuestionBankTopicsApi +
          `?userIdentifier=${userDetail?.userIdentifier}&jobGuideIdentifier=${jobGuideIdentifier}`;
      } else {
        url =
          getQuestionBankTopicsApi +
          `?userIdentifier=${userDetail?.userIdentifier}&jobGuideIdentifier=${jobGuideIdentifier}`;
      }

      WebUtils.httpOperations(url, {}, "GET")
        .then((result) => {
          setLoading(false);
          if (
            result.data?.resultStatusInfo?.resultCode?.toLowerCase() ===
            "success"
          ) {
            setQuestionBankTopics(result.data?.data);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  }

  useEffect(() => {
    if (jobGuideIdentifier) {
      getQuestionBankTopics();
      initGetGuideDetails();
    }
  }, [jobGuideIdentifier]);

  return (
    <>
      {loading && <Loader />}
      <div className="flex gap-4 p-4 overflow-x-hidden ">
        {/* Left + Middle Combined */}
        <div
          className={`transition-all duration-500 flex gap-4 sm:flex-row flex-col ${
            open ? "lg:w-[75%] w-full" : "w-full"
          }`}
          // style={{ width: open ? "75%" : "100%" }} // shrink when panel opens
        >
          {/* Left */}
          <div className="sm:w-1/3 w-full">
            <LeftViewComponent
              userDetail={userDetail}
              jobGuideIdentifier={jobGuideIdentifier}
              middleContentRef={middleContentRef}
              guideDetails={guideDetails}
              setTopicSubTopic={setTopicSubTopic}
              currTopicId={currTopicId}
              currSubTopicId={currSubTopicId}
              handleViewJd={handleViewJd}
              questionBankTopics={questionBankTopics}
              questionBankSkills={questionBankSkills}
              setQuestionBankSkills={setQuestionBankSkills}
              currentSkills={currentSkills}
              setCurrentSkills={setCurrentSkills}
              skillRegenerateFlag={skillRegenerateFlag}
              setSkillRegenerateFlag={setSkillRegenerateFlag}
              qbSkillType={qbSkillType}
              setQBSkillType={setQBSkillType}
              industryId={industryId}
            />
          </div>

          {/* Middle */}
          <div className="flex-1" ref={middleContentRef}>
            <MiddleViewGuide
              guideDetails={guideDetails}
              setGuideDetails={setGuideDetails}
              currTopicId={currTopicId}
              currSubTopicId={currSubTopicId}
              jobGuideIdentifier={jobGuideIdentifier}
              industryId={industryId}
              setOpen={setOpen}
              open={open}
              setActiveIndex={setActiveIndex}
              buttons={buttons}
              activeIndex={activeIndex}
              currentSkills={currentSkills}
              setCurrentSkills={setCurrentSkills}
              skillRegenerateFlag={skillRegenerateFlag}
              setSkillRegenerateFlag={setSkillRegenerateFlag}
              qbSkillType={qbSkillType}
              setQBSkillType={setQBSkillType}
            />
          </div>
        </div>

        {/* Right (Slider Panel) */}
        <div
          className={`transition-all duration-500 lg:static overflow-x-hidden absolute z-50 lg:right-0 right-2 max-w-[400px]  lg:bottom-0 bottom-2 ${
            open ? "lg:w-[25%] md:w-[75%] w-[95%]" : "w-0"
          } `}
          style={{
            overflow: open ? "visible" : "hidden",
          }}
        >
          <Slidersection
            open={open}
            onClose={() => {
              setOpen(false);
              setActiveIndex(null);
            }}
            activeIndex={activeIndex}
            width="100%" // fill its parent width
            children={{
              panel: (
                <div className="sm:h-[60vh] h-[80vh] overflow-x-hidden">
                  {activeIndex === 0 && (
                    <JobDetails
                      guideDetails={guideDetails}
                      handleViewJd={handleViewJd}
                    />
                  )}
                  {activeIndex === 1 && (
                    <Notes
                      currTopicId={currTopicId}
                      currSubTopicId={currSubTopicId}
                      industryId={industryId}
                    />
                  )}
                  {activeIndex === 2 && <VideoCurator />}
                </div>
              ),
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ViewGuideMain;
